import React from 'react'

function Error(): JSX.Element {
  return <div>error</div>
}

export default React.memo(Error)
